<ion-header *ngIf="isLayoutTabs == 0 && informacoesAplicativo.tabs.length > 1">
  <ion-toolbar [ngClass]="{'dark': dark, 'white' : !dark, }" mode="md">
    <ion-buttons slot="start" *ngIf="iconsConfigs">
      <div class="notification-icon" (click)="notificacoes(userProvider.loggedUser.id)">
        <i class="fa-light fa-bell" [ngStyle]="{ color: colorIcons }"></i>

        <ion-badge
          color="danger"
          class="notification-badge"
        >
          {{notificationsLength}}
        </ion-badge>
      </div>

      <div (click)="configuracao();">
        <i class="fa-light fa-gear" [ngStyle]="{'color': colorIcons}"></i>
      </div>
    </ion-buttons>

    <ion-segment
      mode="md"
      [(ngModel)]="tabSelecionada"
      (ionChange)="onSegmentSelected(tabSelecionada)"
      [ngClass]="{'dark': dark, 'white' : !dark}"
    >
      <ion-segment-button
        *ngFor="let tab of informacoesAplicativo.tabs; let i = index"
        [value]="i"
      >
        <ion-label>{{ tab.label }}</ion-label>
      </ion-segment-button>
    </ion-segment>

    <ion-buttons
      slot="end"
      class="justify-icon-img"
      *ngIf="iconsConfigs"
      style="display: flex; align-items: center; justify-content: flex-end"
    >
      <i
        *ngIf="userProvider.isAnonimo()"
        (click)="openLogin();"
        class="fa-light fa-circle-user user-profile"
        [ngStyle]="{'color': colorIcons}"
      >
      </i>

      <ion-avatar *ngIf="!userProvider.isAnonimo()" class="img-profile">
        <img
          (click)="perfil(userProvider.loggedUser.id);"
          [src]="userProvider.loggedUser?.foto | image:' '"
        />
      </ion-avatar>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  [fullscreen]="isLayoutTabs == 1"
  [ngStyle]="
    {
      '--background': backgroundContent,
    }
  "
>
  <div #tab class="main-tab">
    <ng-container
      *ngFor="let tab of informacoesAplicativo.tabs; let i = index;"
    >
      <div class="tab" *ngIf="tabSelecionada == i">
        <div *ngIf="tab.background == 4">
          <video
            *ngIf="tab.background == '4' && playingVideo"
            preload="auto"
            style="z-index: -10"
            autoplay
            playsinline
            muted
            loop
            #video
          >
            <source src="assets/video/video.mp4 " type="video/mp4" />
          </video>

          <div
            class="gradient"
            [ngStyle]="{'background': getBackgroundVideo(tab), 'z-index': getIndex()}"
          ></div>
        </div>

        <div [ngClass]="tab.margem == '1' ? ['tab-margem'] : []">
          <div *ngIf="isBarraAcao && isLayoutTabs == 0 && !iconsConfigs">
            <ion-grid class="grid-cog-img">
              <ion-row
                class="ion-justify-content-between ion-align-items-center"
              >
                <ion-col class="ion-text-start">
                  <ion-buttons style="display: flex; align-items: center">
                    <div class="notification-icon" (click)="notificacoes(userProvider.loggedUser.id)">
                      <i class="fa-light fa-bell" [ngStyle]="{ color: colorIcons }"></i>

                      <ion-badge
                        *ngIf="notificationsLength > 0"
                        color="danger"
                        class="notification-badge"
                      >
                        {{notificationsLength}}
                      </ion-badge>
                    </div>

                    <div (click)="configuracao();">
                      <i
                        class="fa-light fa-gear"
                        [ngStyle]="{'color': colorIcons}"
                      ></i>
                    </div>
                  </ion-buttons>
                </ion-col>

                <ion-col size="3" class="ion-text-end">
                  <ion-buttons
                    class="justify-icon-img"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <i
                      *ngIf="userProvider.isAnonimo()"
                      (click)="openLogin();"
                      class="fa-light fa-circle-user user-profile"
                      [ngStyle]="{'color': colorIcons}"
                    >
                    </i>

                    <ion-avatar *ngIf="!userProvider.isAnonimo()">
                      <img
                        (click)="perfil(userProvider.loggedUser.id);"
                        [src]="userProvider.loggedUser?.foto | image:' '"
                      />
                    </ion-avatar>
                  </ion-buttons>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>

          <ion-grid class="remove-padding">
            <ng-container *ngFor="let line of tab.linhas">
              <ion-row class="ion-align-items-center">
                <ion-col
                  *ngFor="let field of line; let i = index"
                  [size]="getActionWidth(field)"
                  [ngClass]="{'remove-padding-col':
                    field.margem_botao == '0'
                    && field.tipo_botao != '3'
                    && field.tipo_botao != '5'
                    && field.tipo_botao != '6' ||
                    field.margem_botao == '1' &&
                    field.tipo_botao == '2' && field.tamanho == '4',
                    'padding-right': isFirstOfTwoBotoesTipo1(i, line),
                    'padding-left': isSecondOfTwoBotoesTipo1(i, line)
                  }"
                >
                  <botao-image
                    *ngIf="field.tipo_botao === '1'"
                    (click)="botaoClick(field)"
                    [config]="field"
                  ></botao-image>

                  <botao-icone
                    *ngIf="field.tipo_botao === '2'"
                    (click)="botaoClick(field)"
                    [config]="field"
                  ></botao-icone>

                  <botao-escrito
                    *ngIf="field.tipo_botao === '4'"
                    (click)="botaoClick(field)"
                    [config]="field"
                  ></botao-escrito>

                  <noticia-destaque
                    *ngIf="field.tipo_botao === '3'"
                    [config]="field"
                  ></noticia-destaque>

                  <lista-noticia
                    *ngIf="field.tipo_botao === '5'"
                    (click)="botaoClick(field)"
                    [config]="field"
                  ></lista-noticia>

                  <slider-noticia
                    *ngIf="field.tipo_botao === '6'"
                    (click)="botaoClick(field)"
                    [config]="field"
                  ></slider-noticia>

                  <titulo
                    *ngIf="field.tipo_botao === '7'"
                    (click)="botaoClick(field)"
                    [config]="field"
                  ></titulo>

                  <slider-eventos
                    *ngIf="field.tipo_botao === '8' || field.tipo_botao === '9'"
                    (click)="botaoClick(field)"
                    [config]="field"
                  ></slider-eventos>
                </ion-col>
              </ion-row>
            </ng-container>
          </ion-grid>
        </div>
      </div>
    </ng-container>
  </div>
</ion-content>
